import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import core from '@/com/mixins/core.mixin'
import ServiceLogin from '@/services/service.login'

import axios from 'axios'

// Every request must carry the httpOnly refresh cookie. api.js sets this
// per-request too; this covers any raw axios call that bypasses it.
axios.defaults.withCredentials = true

// Setup axios interceptor to handle 401/403 errors (expired/invalid tokens)
// This must be done here to avoid circular dependencies
axios.interceptors.response.use(
  response => response,
  error => {
    const url = error.config && error.config.url ? error.config.url : ''
    // A 401 from the auth endpoints themselves is expected (no valid refresh
    // cookie yet, or already logged out) — logging out in response would fire
    // a pointless logout call and redirect a visitor who was never logged in.
    const isAuthEndpoint = url.includes('/v1/sec/refresh') || url.includes('/v1/sec/logout')

    if (!isAuthEndpoint && error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Token is expired, invalid, or forbidden - logout via store and redirect to home
      store.dispatch('stateUser/logout')
      router.push({ name: 'home' })
    }
    return Promise.reject(error)
  }
)

// Trade the httpOnly refresh cookie for a fresh access token before the app
// mounts, so a page reload doesn't force a re-login. This has to resolve
// before the router's first navigation or the guard would bounce a still
// logged-in user to the welcome page.
async function bootstrapAuth () {
  try {
    const result = await ServiceLogin.refresh()
    if (result && result.data && result.data.token) {
      await store.dispatch('stateUser/authenticate', result.data.token)
      if (result.data.uid) {
        store.commit('stateUser/SET_USER', {
          uid: result.data.uid,
          email: result.data.email,
          pid: result.data.pid,
          //role: result.data.role
        })
      }
    }
  } catch {
    // No valid refresh cookie, or it expired — a normal state for a
    // logged-out visitor, not an error worth surfacing.
  }
}

bootstrapAuth().then(() => {
  createApp(App)
    .mixin({mixins: [core] })
    .use(store)
    .use(router).mount('#app')
})
